import React from 'react';
import { PropTypes } from 'prop-types';
import { selectedClassName } from 'components/PaymentSwitcher/constants';
import { StyledSwitcher, StyledSwitchHandle, StyledSwitchOption } from './SwitcherStyles';

export const Switcher = React.memo((props) => {
  const { leftTitle, rightTitle, enabled, toggle } = props;

  return (
    <StyledSwitcher enabled={enabled} onClick={() => toggle(!enabled)}>
      <StyledSwitchOption
        left
        className={!enabled ? selectedClassName : ''}
        onClick={(e) => {
          toggle(false);
          e.stopPropagation();
        }}
      >
        {leftTitle}
      </StyledSwitchOption>
      <StyledSwitchHandle enabled={enabled} />
      <StyledSwitchOption
        right
        className={enabled ? selectedClassName : ''}
        onClick={(e) => {
          toggle(true);
          e.stopPropagation();
        }}
      >
        {rightTitle}
      </StyledSwitchOption>
    </StyledSwitcher>
  );
});

Switcher.propTypes = {
  leftTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  rightTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  enabled: PropTypes.bool.isRequired,
};
